export default __webpack_public_path__ + "static/media/logoicon.7396311e.png";